












































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnTitle, AcgnAuditStep, AcgnUpload } from '@acgn/herm/src/ui';
import { AttributeMixin, RenderMenuMixin } from '@/mixins';
import { AcgnFormContent, AcgnFormTitle, AcgnTaskMenu, AcgnGroupEdit, AcgnApprovalDetail } from '@/components/';
import { AcgnTaskAuditing } from './components/';
import { AcgnUploadFile } from './components/task-auditing/components';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';
import { getComicUploadImageSts } from '@/api/ossClient';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import { setDateTimeStamp } from '@acgn/herm/src/util/time';
import event from '@acgn/herm/src/util/event';

const TaskGroupAction = namespace('desk/taskGroup').Action;

interface ComicDetailType { // 编辑结构类型
  name: string; // 名称
}

// 组件申明
@Component({
  components: {
    AcgnTitle,
    AcgnAuditStep,
    AcgnFormContent,
    AcgnFormTitle,
    AcgnTaskAuditing,
    AcgnUpload,
    AcgnTaskMenu,
    AcgnGroupEdit,
    AcgnUploadFile,
    AcgnApprovalDetail
  },
  mixins: [AttributeMixin, RenderMenuMixin]
})

/**
 * 任务
 */
export default class ComicDetail extends Vue {
  @TaskGroupAction private getTaskDetail: any; // 获取任务组

  private comicId: any = 0;
  private appro: any = false;
  private uploadFile: any = false;
  private task_id: any = 0;
  private formData: ComicDetailType = {
    name: ''
  };
  private comicMessage: any = {}; // 漫画信息
  private examineList: any = [];  // 审核列表
  private manageGroupList: any = [
    {
      id: 1,
      name: '项目待办',
      icon: 'ift-project_2',
      url: 'desk-workerDetail',
      belong: 'worker',
      selected: false,
    }
  ]; // 选中的管理组


  // 上传稿件
  private uploadMoleSta(data: any) {
    this.uploadFile = data;
  }

  // 刷新列表
  private refreshApproList(data: any) {
    // this.comicMessage.linkName = data.name;
    // this.comicMessage.linkId = data.id;
    this.comicMessage = {
      ...this.comicMessage,
      linkName: data.name,
      linkId: data.id
    };
    this.appro = true;
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-task-menu authorityCode="3003" source="worker"
        hasTask={true}
        getProjectList={this.getProjectList} manageGroupList={this.manageGroupList}></acgn-task-menu>
    );
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      name: [
        { required: true, message: '标题不可为空', trigger: 'blur' }
      ]
    };

    return rules;
  }

  private created() {
    this.comicId = this.$route.params.id;
    this.task_id = parseInt(this.$route.params.task_id, 10);
  }

  private getProjectList(data: any) {
    this.comicMessage = data;
    this.comicMessage.projectId = this.comicId;
    this.comicMessage.dead_line = setDateTimeStamp(this.comicMessage.dead_line, 'YYYY-MM-DD HH:mm:ss');
    this.refreshExamine();
  }

  private async refreshExamine() {
    const { result } = await this.getTaskDetail({ task_id: this.comicMessage.id});
    this.examineList = result;
  }

  // 获取状态
  private getStadius(row: any) {
    return (
      <span class="detail-sta">已过审</span>
    );
  }

  // 返回列表
  private goBack() {
    this.$router.back();
  }
}
